import { createFileRoute } from "@tanstack/react-router";
import { HomepageView } from "../../views/public/homepage/homepage-view";

interface RootSearchParams {
  loggedOut: boolean;
}

export const Route = createFileRoute("/_public/home")({
  validateSearch: (search: Record<string, unknown>): RootSearchParams => {
    return {
      loggedOut: Boolean(search?.loggedOut),
    };
  },
  component: HomepageView,
});
